import IconStatus from './IconStatus.vue'
import LinkCopy from './LinkCopy.vue'
import Tabs from './Tabs.vue'

export default {
    'tl-icon-status': IconStatus,
    'tl-link-copy': LinkCopy,
    'tl-tabs': Tabs,
}
